import { useEffect, useState } from 'react';

const useCapsLock = () => {
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Проверяем состояние CapsLock при нажатии любой клавиши
      setIsCapsLockOn(event.getModifierState('CapsLock'));
    };

    // Также можно проверить начальное состояние при загрузке
    // Для этого нужно создать синтетическое событие или использовать начальное состояние из event, но проще установить при первом нажатии

    window.addEventListener('keydown', handleKeyDown);

    // Очистка слушателя при размонтировании компонента
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return isCapsLockOn;
};

export default useCapsLock;